import API from "../../../api/axiosClient";
import {
    GroupLearningDashboardDto,
    CreateGroupLearningLocationDto,
    UpdateGroupLearningLocationDto,
    CoordinatorLearningLocationDto,
    LearningRequestStatus
} from "../types/GroupLearningLocation";

const url = "GroupLearningLocation";

const GroupLearningLocationService = {

    getDashboard: async (groupId: string) => {
        const res = await API.get<GroupLearningDashboardDto>(
            `${url}/dashboard/${groupId}`);

        return res.data;
    },

    create: async (
        dto: CreateGroupLearningLocationDto
    ) => {
        await API.post(url, dto);
    },

    update: async (
        dto: UpdateGroupLearningLocationDto
    ) => {
        await API.put(url, dto);
    },

    getCoordinatorList: async (
    groupId: string
): Promise<CoordinatorLearningLocationDto[]> => {

    const response = await API.get(
        `${url}/group/${groupId}`
    );

    return response.data;

},
updateStatus: async (
    groupLearningLocationId: string,
    status: LearningRequestStatus
) => {

    await API.put(
        `${url}/status`,
        {
            groupLearningLocationId,
            status
        });

}

};

export default GroupLearningLocationService;